module.exports = __webpack_public_path__ + "img/CIMG0278.ec695cf4.jpg";